export default "__VITE_ASSET__3B1ITjnL__ 584w";